// @todo once we've reached the end of the video, go to the conclusion tab
import {
  getPlayerLinkFromVimLink,
  isWindowInIframe,
  hide,
  show,
} from "./utils";

import expandImgSrc from "./assets/img/expand-solid.svg";
import rightArrowImgSrc from "./assets/img/right-arrow.svg";

export default class OverlayManager {
  constructor({
    appendTo,
    // iframe,
    videoUrl,
    title,
    onVideoEnd = () => {},
    startTimes = [],
    deploymentUrl = ``,
  }) {
    // holds the state for the current chapter we're in
    this.currentChapter = -1;

    this.isVideoPlaying = false;

    this.startTimes = startTimes;
    this.onVideoEnd = onVideoEnd;

    this.deploymentUrl = deploymentUrl;

    this.iframe,
      this.wrapper,
      this.player,
      this.playButton,
      this.overlay,
      this.overlayContent,
      this.controlClose,
      this.controlTitle;

    // video metadata
    this.videoUrl = videoUrl;
    this.title = title;

    this.root = appendTo;

    this._pauseVideo = this._pauseVideo.bind(this);
    this._playVideo = this._playVideo.bind(this);

    this._initElements();

    this.player.on("timeupdate", (data) => this._onVideoUpdate(data));
  }

  _updateDocumentTitle(title) {
    document.querySelector("title").innerHTML = title;
  }

  _initElements() {
    const $wrapper = $("<div/>")
      .attr("class", "video-player")
      .attr("data-vimeo-initialized", "true");

    const $iframe = $("<iframe/>")
      .attr("src", getPlayerLinkFromVimLink(this.videoUrl))
      .attr("width", "426")
      .attr("height", "170")
      .attr("frameborder", "0")
      .attr("allow", "autoplay; fullscreen")
      .attr("title", this.title)
      .attr("data-ready", "true")
      .attr("class", "video");

    const $playButton = $("<button/>").attr("class", "button").html("Play");

    const $expandButton = $("<div/>")
      .attr("class", "button expand-button")
      .html(`<img src="${expandImgSrc}" />`);
    const $visitSrcButton = $("<div/>")
      .attr("class", "button expand-button")
      .html(`<img src="${expandImgSrc}" />`);

    $playButton.appendTo($wrapper);

    // only add expand button if current app is in an iframe
    // isWindowInIframe() &&
    if (isWindowInIframe()) {
      $visitSrcButton.appendTo($wrapper);
    } else {
      $expandButton.appendTo($wrapper);
    }

    $iframe.appendTo($wrapper);
    $wrapper.appendTo(this.root);

    this.iframe = $iframe.get(0);
    this.player = new Vimeo.Player(this.iframe);
    this.player.setCurrentTime(0);
    this.player.setVolume(1);
    this.playButton = $playButton.get(0);

    this.expandButton = $expandButton.get(0);
    this.visitSrcButton = $visitSrcButton.get(0);

    this.wrapper = $wrapper.get(0);

    this.player.on("fullscreenchange", ({ fullscreen }) => {
      console.log(`fullscreen`, fullscreen);
      switch (fullscreen) {
        case true:
          console.log("entered full screen");
          this._toggleVideo(true, false);
          break;
        case false:
          console.log("exited full screen");
          this._toggleVideo(false, false);
          // this.player.play();
          break;
        default:
          break;
      }
    });

    this.expandButton.addEventListener("click", () => {
      this.player.requestFullscreen();
    });
    this.visitSrcButton.addEventListener("click", () => {
      window.open(this.deploymentUrl);
    });
    // Play/pause functionality
    this.playButton.onclick = this._playVideo;
    this.wrapper.addEventListener("click", () => {
      // this._toggleVideo(false, false)
      this.player.getFullscreen().then((isFullscreen) => {
        // dont allow pause of video by clicking container
        // when fullscreen
        !isFullscreen && this._toggleVideo(false, false);
      });
    });
    this._buildOverlay();
  }

  _buildOverlay() {
    const $overlay = $("<div/>").attr("class", "overlay hidden");
    $overlay.appendTo(this.root);

    const $overlayControl = $("<span/>").attr("class", "overlay__control");
    const $controlClose = $("<span/>")
      .attr("class", "overlay__close")
      .html(`X`);
    const $controlTitle = $("<span/>").attr("class", "overlay__title");
    const $overlayContent = $("<iframe/>")
      .attr("class", "overlay__content")
      .html(`content`);

    $overlayControl.append($controlClose);
    $overlayControl.append($controlTitle);
    $overlay.append($overlayControl);

    $overlay.append($overlayContent);

    // this.popUpControl = $overlayControl.get(0);
    this.overlay = $overlay.get(0);
    this.overlayContent = $overlayContent.get(0);
    this.controlClose = $controlClose.get(0);
    this.controlTitle = $controlTitle.get(0);

    this.controlClose.addEventListener("click", () =>
      this._toggleVideo(true, false)
    );
  }

  // this fires every 250ms (minimum) which is not ideal
  // (takes longer on phones)
  _onVideoUpdate(data) {
    const now = data.seconds;

    // find out which chapter we should be on based on the current video time
    const chapterNum = this.startTimes.reduceRight(
      (acc, curr, idx) => (now < curr ? idx - 1 : acc),
      this.startTimes.length - 1
    );

    if (this.currentChapter !== chapterNum) {
      this.currentChapter = chapterNum;
      this.onVideoEnd(this.currentChapter);
    }
  }

  _pauseVideo(e) {
    e.stopPropagation();
    this.player.pause();
    show(this.playButton);
  }

  _toggleVideo(playVideo = true, showOverlay = false) {
    if (playVideo) {
      this.player.play();
      this._hideOverlay();
      hide(this.playButton);
    } else {
      this.player.pause();
      show(this.playButton);
      if (showOverlay) {
        this._showOverlay();
      }
    }
  }

  _playVideo(e) {
    e.stopPropagation();
    this.player.play();
    hide(this.playButton);
  }

  _hideOverlay() {
    this.wrapper.classList.remove("dimmed");
    this.player.play();
    hide(this.overlay);
    this.overlayContent.src = "";
  }

  _showOverlay() {
    this.player.pause();
    this.wrapper.classList.add("dimmed");
    show(this.overlay);
  }

  _togglePlayButton(e) {
    e.stopPropagation();
    this.player.play();
    hide(this.playButton);
  }

  updateChapter(id) {
    this.player.off("timeupdate");
    this.currentChapter = id;
    this._toggleVideo(true, false);
    this.onVideoEnd(this.currentChapter);
    // This is a complete band-aid fix to deal with concurrency issues
    // from queued timeupdate callbacks.
    // As mentioned in https://github.com/vimeo/player.js/#timeupdate,
    // the timeupdate callback fires every 250ms but, empirically, on phones
    // it takes much longer. This was causing a flicker when the _onVideoEnd
    // callback was being called twice, on for the previous chapter
    // and one for the current. This setTimeout sets to fix this, and it
    // seems to be working for now.

    // TODO we need to simplify and make more functional the bidirectional
    // communication logic between OverlayManager and ChapteredVideo

    // TODO there should not be the need to
    setTimeout(() => {
      this.player.on("timeupdate", (data) => this._onVideoUpdate(data));
    }, 1000);
  }

  updateOverlayContent(content) {
    this.controlTitle.innerHTML = `<a href=${content.link} target="__blank">${content.title} →</a>`;
    this.overlayContent.src = content.link;
    this._toggleVideo(false, true);
  }
}
